/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, {useContext, useEffect, useState} from "react";
import Stockchart from "../stockchart_plotly";
import DisplayCards from "../metricCards";
import DynamicStockCharts from "../dynamicStockCharts_plotly";
import FundaTeaser from "../fundamentals/stockFundamentalTeaser";
import Plot from "react-plotly.js";
import {fetchMarketIndices, fetchPage} from "../../api";
import MarketBreadth from "./market_breadth";
import SectorPerformance from "./sector_performance";
import LiveMarketOverview from "../marketsnap";


const IndexCards = ({data}) => {
  console.log("INDEX CARDS",data);
  const indices = data
    const price_list = data?.map((column, index) => ({
      title: column.symbol,
      value: column.close.toFixed(2),
      change: column.percent_change.toFixed(2)
    }));
  return (
    // <div className="grid grid-cols-3 gap-4 p-4">
    //   {indices.map((index) => (
    //     <div
    //       key={index.symbol}
    //       className={`p-3 rounded-lg shadow-lg  w-64 text-center ${
    //         index.percent_change >= 0 ? "bg-green-100" : "bg-red-100"
    //       }`}
    //     >
    //       <h3 className="text-xl font-bold">{index.name}</h3>
    //       <p className="text-sm text-gray-500">{index.symbol}</p>
    //       <p className="text-2xl font-semibold">{index.close}</p>
    //         <p className={`text-lg ${index.percent_change >= 0 ? "text-green-600" : "text-red-600"}`}>
    //           {isNaN(parseFloat(index.percent_change))
    //             ? "N/A"
    //             : `${parseFloat(index.percent_change).toFixed(2)}%`}
    //         </p>
    //
    //       <Plot
    //         data={[
    //           {
    //             x: ["Open", "High", "Low", "Close"],
    //             y: [
    //               index.open,
    //               index.high,
    //               index.low,
    //               index.close,
    //             ],
    //             type: "scatter",
    //             mode: "lines+markers",
    //             marker: { color: index.percent_change >= 0 ? "green" : "red" },
    //           },
    //         ]}
    //         layout={{
    //           width: 200,
    //           height: 100,
    //           margin: { t: 10, b: 10, l: 30, r: 10 },
    //           xaxis: { showgrid: false, zeroline: false, visible: false },
    //           yaxis: { showgrid: false, zeroline: false, visible: false },
    //         }}
    //       />
    //     </div>
    //   ))}
    // </div>
            <div>
        <DisplayCards cardList={price_list} color={"#0b5585"}/>
            </div>
  );
}

const IndexPerformanceChart = ({indices}) => {
    const DEFAULT_TICKERS = ["NIFTY 50", "S&P500"];

  // const [indices, setIndices] = useState([]);
  const [timeframe, setTimeframe] = useState("1Y");
  const [selectedTickers, setSelectedTickers] = useState(DEFAULT_TICKERS);


const TIMEFRAMES = {
  "1M": 30,
  "3M": 90,
  "6M": 180,
  "1Y": 365,
};
  // Function to filter data by selected timeframe
  const filterDataByTimeframe = (data) => {
    const today = new Date();
    const cutoffDate = new Date();
    cutoffDate.setDate(today.getDate() - TIMEFRAMES[timeframe]);

    return data.filter((point) => new Date(point.date) >= cutoffDate);
  };

  // Function to normalize values using Min-Max Scaling
  const normalizeData = (data) => {
    const groupedData = {};

    // Group by Ticker
    data.forEach((entry) => {
      const { symbol, date, close } = entry;

      if (!groupedData[symbol]) {
        groupedData[symbol] = [];
      }

      groupedData[symbol].push({ date, close });
    });

    // Normalize each ticker's data
    Object.keys(groupedData).forEach((ticker) => {
      const prices = groupedData[ticker].map((d) => d.close);
      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);

      groupedData[ticker] = groupedData[ticker].map((d) => ({
        date: d.date,
        close: (d.close - minPrice) / (maxPrice - minPrice), // Normalize to [0,1]
      }));
    });

    return groupedData;
  };

  // Transform Data for Plotly (Filtered by Selected Tickers)
  const transformDataForPlotly = (data) => {
    const groupedData = normalizeData(data);
    return Object.keys(groupedData)
      .filter((ticker) => selectedTickers.includes(ticker)) // ✅ Only selected tickers
      .map((ticker) => ({
        x: groupedData[ticker].map((point) => point.date),
        y: groupedData[ticker].map((point) => point.close),
        type: "scatter",
        mode: "lines",
        name: ticker,
      }));
  };

  const filteredData = filterDataByTimeframe(indices);
  const plotData = transformDataForPlotly(filteredData);

  // Handle Ticker Selection Toggle
  const toggleTickerSelection = (ticker) => {
    setSelectedTickers((prev) =>
      prev.includes(ticker)
        ? prev.filter((t) => t !== ticker) // Remove if already selected
        : [...prev, ticker] // Add if not selected
    );
  };

  return (
    <div style={styles.container}>
      {/* Left Chart Section */}
      <div style={styles.chartContainer}>
        {/* Title with Timeframe Selector */}
        <div style={styles.header}>
          <h2 style={styles.title}>Market Performance</h2>
          <div style={styles.timeframeContainer}>
            {Object.keys(TIMEFRAMES).map((key) => (
              <span
                key={key}
                onClick={() => setTimeframe(key)}
                style={{
                  ...styles.timeframeOption,
                  textDecoration: timeframe === key ? "underline" : "none",
                  fontWeight: timeframe === key ? "bold" : "normal",
                }}
              >
                {key}
              </span>
            ))}
          </div>
        </div>

        {/* Performance Chart */}
        <Plot
          data={plotData}
          layout={{
            // width: 800,
            height: 800,
            // title: `Market Performance (${timeframe})`,
            xaxis: { title: "Date", type: "date" },
            yaxis: { title: "Normalized Close Price (0-1)" },
          }}
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
        />
      </div>

      {/* Right Sidebar for Selecting Indices */}
      <div style={styles.sidebar}>
        {/*<h3 style={styles.sidebarTitle}>Select Indices</h3>*/}
        <ul style={styles.tickerList}>
          {Array.from(new Set(indices.map((i) => i.symbol))).map((ticker) => (
            <li
              key={ticker}
              onClick={() => toggleTickerSelection(ticker)}
              style={{
                ...styles.tickerItem,
                fontWeight: selectedTickers.includes(ticker) ? "bold" : "normal",
              }}
            >
              {ticker}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};



function StockSnapshot({data,ticker}) {
    // Convert to list of dictionaries
    if (!data || !data.columns || !data.data || !data.data[0]) {
            // console.log("PRICE LIST",data)
                    console.log("PRICE Columns",data.columns)
            // console.log("PRICE DATA",data[0])
            // console.log("PRICE LIST",data)

        return <p>Loading stock data...</p>;
    }
    const price_list = data?.columns.map((column, index) => ({
      title: column,
      value: data.data[0][index],
      change: null
    }));
    return(
        <div>
        <DisplayCards cardList={price_list} color={"#0b5585"}/>
        <FundaTeaser symbol={ticker}/>
        </div>
    );
}

function StockGraph({data}) {
    return(
    <Stockchart symbol={data} volume={true} bbFlag={true} levelFlag={true}/>
    );
}
function Benchmarks({data,ticker}) {
    // Convert to list of dictionaries
    if (!data || !data.columns || !data.data || !data.data[0]) {
            // console.log("PRICE LIST",data)
                    console.log("PRICE Columns",data.columns)
            // console.log("PRICE DATA",data[0])
            // console.log("PRICE LIST",data)

        return <p>Loading stock data...</p>;
    }
    const price_list = data?.columns.map((column, index) => ({
      title: column,
      value: data.data[0][index],
      change: null
    }));
    return (
        <div>
            <p>Period Performance</p>
        <DisplayCards cardList={price_list} color={"#0b5585"}/>
         <DynamicStockCharts stocks={[ticker,'NIFTY 50']} metric="return" />
        </div>
    )
}
function Risk({risk1,risk2,ticker}) {
    // Convert to list of dictionaries
    if (!risk1 || !risk1.columns || !risk1.data || !risk1.data[0]) {
            // console.log("PRICE LIST",data)
                    console.log("PRICE Columns",risk1.columns)
            // console.log("PRICE DATA",data[0])
            // console.log("PRICE LIST",data)

        return <p>Loading stock data...</p>;
    }
    const price_list = risk1?.columns.map((column, index) => ({
      title: column,
      value: risk1.data[0][index],
      change: null
    }));

    console.log("BETA",risk2)
      return (
    <div className="risk-container">
      <h2>Risk Indicators for {ticker}</h2>

      {/* Beta Gauge */}
      <Plot
        data={[
          {
            type: "indicator",
            mode: "gauge+number",
            value: risk2.beta,
            title: { text: "Beta" },
            gauge: { axis: { range: [0, 2] }, bar: { color: "blue" } },
          },
        ]}
        layout={{ width: 300, height: 300 }}
      />

      {/* Volatility Gauge */}
      <Plot
        data={[
          {
            type: "indicator",
            mode: "gauge+number",
            value: risk2.volatility,
            title: { text: "Volatility (%)" },
            gauge: { axis: { range: [0, 100] }, bar: { color: "orange" } },
          },
        ]}
        layout={{ width: 300, height: 300 }}
      />

      {/* Heatmap for Max Drawdown & Max Loss */}
      <Plot
        data={[
          {
            z: [[risk2.max_drawdown, risk2.max_loss]],
            x: ["Max Drawdown (%)", "Max Loss (%)"],
            y: ["Risk"],
            type: "heatmap",
            colorscale: "RdYlGn",
          },
        ]}
        layout={{ title: "Max Drawdown & Max Loss Heatmap", width: 500, height: 300 }}
      />
     <DisplayCards cardList={price_list.slice(2)} color={"#0b5585"}/>
    </div>
  );
    // return(
    //     <div>
    //     <DisplayCards cardList={price_list} color={"#0b5585"}/>
    //     </div>
    // );
}

const MarketSummary = ({indices}) => {
  // const stockData = useContext(StockContext);
  // const [indices, setIndices] = useState([]);
  const subSections = ["Major Indices", "Market Breadth", "Sector Performance"];
  const [data, setData] = useState(null);
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);



  console.log("SUMMARY DATA  RECVD" , indices);
  // if (!stockData) return <p>Loading stock data...</p>;

  const renderContent = () => {

    switch (activeSubTab) {
        case "Major Indices":
        return  indices.indices?.length > 0 ? (<div align={"center"}>
      {/*<IndexCards data={JSON.parse(indices.indices)} />*/}
      <LiveMarketOverview/>
      <IndexPerformanceChart indices={JSON.parse(indices.hist_df)}/>
            </div>) : (
                <p>Loading data...</p>
              );
      case "Market Breadth":
        return  indices.indices?.length > 0 ? (<div align={"center"}>
      <MarketBreadth />
            </div>) : (
                <p>Loading data...</p>
              );
      case "Sector Performance":
        return  indices.indices?.length > 0 ? (<div align={"center"}>
      <SectorPerformance />
            </div>) : (
                <p>Loading data...</p>
              );
      case "Performance vs Benchmark":
        return data ? (<div align={"center"} style={{height:"700px"}}>
      <Benchmarks data={JSON.parse(data.return_list)} ticker={data.symbol} />
                </div>) : (
                <p>Loading data...</p>
              );
      case "Risk Indicators":
        return data ? (<div align={"center"}>
        {/*<Risk data={JSON.parse(data.risk_list)} ticker={data.symbol}/>*/}
        <Risk risk1={JSON.parse(data.risk_list)} risk2={data.risk_n} ticker={data.symbol}/>
        </div>) : (
                <p>Loading data...</p>
              );
      default:
        return <div>Select a tab to view content.</div>;
    }
  };

  return (
    <div className="section-container">
      {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default MarketSummary;

// ✅ CSS-in-JS (Replacing Tailwind)
const styles = {
  container: {
    display: "flex",
    padding: "16px",
  },
  chartContainer: {
    width: "93%",
    paddingRight: "16px",
  },
  sidebar: {
    width: "7%",
    padding: "16px",
    borderLeft: "1px solid #ccc",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "bold",
  },
  timeframeContainer: {
    display: "flex",
    gap: "12px",
  },
  timeframeOption: {
    cursor: "pointer",
    color: "#555",
  },
  sidebarTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    marginBottom: "8px",
  },
  tickerList: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
  },
  tickerItem: {
    cursor: "pointer",
    color: "#555",
    padding: "4px 0",
    borderBottom: "1px dashed #ccc",
    transition: "color 0.2s",
  },
};